import * as React from 'react'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Text} from 'wix-ui-tpa/Text'
import {useEventDateInformation} from '../../../../../../commons/hooks/dates'
import {EventImage} from './event-image'
import {classes} from './event-info.st.css'
import {EventInfoProps} from '.'

export const EventInfo = ({image, title, location, eventId}: EventInfoProps) => {
  const {isMobile} = useEnvironment()
  const {fullDate} = useEventDateInformation(eventId)

  return (
    <div
      className={classNames(classes.event, {[classes.desktopEvent]: !isMobile})}
      data-hook={DH.EVENT_INFO}
      tabIndex={0}
    >
      {image ? <EventImage image={image} /> : null}
      <div>
        <Text className={classNames(classes.name, {[classes.desktopName]: !isMobile})}>{title}</Text>
        <br />
        <Text className={classes.date}>
          {fullDate}, {location}
        </Text>
      </div>
    </div>
  )
}
